import { AnyAction } from 'redux';
import {
    SET_USER,
    UserPayload,
} from './authActions';

// 1. Define the State Interface
export interface AuthState {
    memberProfile: UserPayload['memberProfile'] | undefined;
    is: any | undefined; // 'identityServer' from payload
    isAuthenticated: boolean;
    isLoading: boolean;
}

const initState: AuthState = {
    memberProfile: undefined,
    is: undefined,
    isAuthenticated: false,
    isLoading: false,
};

// 2. Reducer
export default function reducer(
    state: AuthState = initState,
    action: AnyAction = { type: '' },
): AuthState {
    let nextState: AuthState;

    switch (action.type) {
        case SET_USER:
            nextState = {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                memberProfile: action.payload.memberProfile,
                is: action.payload.identityServer,
            };

            return nextState;

        default:
            return state;
    }
}
